var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticClass: "py-20px py-md-40px",
    attrs: {
      "elevation": "0"
    }
  }, [_c('v-card-title', {
    staticClass: "tit tit--sm primary--text pt-0"
  }, [_c('v-row', {
    attrs: {
      "justify": "end",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v(" 대량 교환하기 ")]), _c('v-spacer'), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('excel-sample', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var click = _ref.click;
        return [_c('v-btn', _vm._g({
          staticClass: "my-n3",
          attrs: {
            "large": "",
            "color": "grey"
          }
        }, {
          click: click
        }), [_c('span', [_vm._v(" 샘플 다운로드 ")])])];
      }
    }])
  })], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('excel-upload', _vm._g(_vm._b({
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref2) {
        var click = _ref2.click;
        return [_c('v-btn', _vm._g({
          staticClass: "my-n3",
          attrs: {
            "large": "",
            "color": "primary"
          }
        }, {
          click: click
        }), [_c('span', [_vm._v(" 대량 업로드 ")])])];
      }
    }])
  }, 'excel-upload', {
    code: _vm.code
  }, false), {
    emit: _vm.emit
  }))], 1)], 1)], 1), _c('v-card-text', {
    staticClass: "py-20px py-md-40px"
  }, [_c('v-row', {
    attrs: {
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": ""
    }
  }, [_c('v-row', {
    staticClass: "row--xx-small"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-img', {
    attrs: {
      "max-width": "20",
      "src": "/images/icon/icon-1.svg"
    }
  })], 1), _c('v-col', [_c('p', {
    staticClass: "page-text page-text--small line-height-13 min-h-lg-54px"
  }, [_vm._v("위에 ‘샘플다운로드’ 버튼을 눌러 대량 업로드용 양식을 다운받습니다.")])])], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": ""
    }
  }, [_c('v-row', {
    staticClass: "row--xx-small"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-img', {
    attrs: {
      "max-width": "20",
      "src": "/images/icon/icon-2.svg"
    }
  })], 1), _c('v-col', [_c('p', {
    staticClass: "page-text page-text--small line-height-13 min-h-lg-54px"
  }, [_vm._v("도서교환권이 있는 첫번째 줄은 수정하지 않고 두번째 줄부터 핀을 입력합니다.")])])], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": ""
    }
  }, [_c('v-row', {
    staticClass: "row--xx-small"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-img', {
    attrs: {
      "max-width": "20",
      "src": "/images/icon/icon-3.svg"
    }
  })], 1), _c('v-col', [_c('p', {
    staticClass: "page-text page-text--small line-height-13 min-h-lg-54px"
  }, [_vm._v("파일을 저장 후 위에 ‘대량 업로드’ 버튼을 눌러 저장한 파일을 업로드합니다.")])])], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": ""
    }
  }, [_c('v-row', {
    staticClass: "row--xx-small"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-img', {
    attrs: {
      "max-width": "20",
      "src": "/images/icon/icon-4.svg"
    }
  })], 1), _c('v-col', [_c('p', {
    staticClass: "page-text page-text--small line-height-13 min-h-lg-54px"
  }, [_vm._v("파일 업로드 후 ‘상품권 교환하기’ 버튼을 누르면 완료됩니다.")])])], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }